export class DocumentEditBehavior {
  shouldUpdateCreateDateOnEditStart: boolean;
  shouldRollbackCreateDateOnTemporarySave: boolean;
  shouldUpdateHisInformationOnEditStart: boolean;
  shouldUpdateHisInformationEmptyObjectOnly: boolean;
  isCommitPhase: boolean;
  enableButtonControl: boolean;
  shouldPrintSpecifiedSectionAtFirstRegistration: boolean;
  shouldIndicatePrintButtonForcibly: boolean;
  shouldUpdateAllHisItemsInExtraSectionWhenQuote: boolean;
  shouldExecutePostRegistrationApplication: boolean;
  shouldFillDoctorAutomaticallyOnEditStart: boolean;
  shouldCreateCollaborationSupplement: boolean;

  clone(): DocumentEditBehavior {
    const cloned = new DocumentEditBehavior();
    cloned.shouldUpdateCreateDateOnEditStart = this.shouldUpdateCreateDateOnEditStart;
    cloned.shouldRollbackCreateDateOnTemporarySave = this.shouldRollbackCreateDateOnTemporarySave;
    cloned.shouldUpdateHisInformationOnEditStart = this.shouldUpdateHisInformationOnEditStart;
    cloned.shouldUpdateHisInformationEmptyObjectOnly = this.shouldUpdateHisInformationEmptyObjectOnly;
    cloned.isCommitPhase = this.isCommitPhase;
    cloned.enableButtonControl = this.enableButtonControl;
    cloned.shouldPrintSpecifiedSectionAtFirstRegistration = this.shouldPrintSpecifiedSectionAtFirstRegistration;
    cloned.shouldIndicatePrintButtonForcibly = this.shouldIndicatePrintButtonForcibly;
    cloned.shouldUpdateAllHisItemsInExtraSectionWhenQuote = this.shouldUpdateAllHisItemsInExtraSectionWhenQuote;
    cloned.shouldExecutePostRegistrationApplication = this.shouldExecutePostRegistrationApplication;
    cloned.shouldFillDoctorAutomaticallyOnEditStart = this.shouldFillDoctorAutomaticallyOnEditStart;
    cloned.shouldCreateCollaborationSupplement = this.shouldCreateCollaborationSupplement;
    return cloned;
  }
}
